export default __webpack_public_path__ + "static/media/26.003eeba1.svg";